import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-thermometer',
  templateUrl: './thermometer.component.html',
  styleUrls: ['./thermometer.component.scss']
})
export class ThermometerComponent implements OnInit {

  @Input() min;
  @Input() max;
  @Input() score;
  color1 = false;
  color2 = false;
  color3 = false;
  color4 = false;
  value = '';
  widtElement: Element;

  constructor() { }

  ngOnInit() {
    this.startColorCircle();
  }

  private startColorCircle() {
    let barem = 0;
    if (+this.score <= 437.5) {
      this.color1 = true;
      barem = +this.score - 300;
      this.value = this.getPercent(barem);
    } else if (+this.score <= 575) {
      this.color2 = true;
      barem = +this.score - 437.5;
      this.value = this.getPercent(barem);
    } else if (+this.score <= 712.5) {
      this.color3 = true;
      barem = +this.score - 575;
      this.value = this.getPercent(barem);
    } else if (+this.score <= 850) {
      this.color4 = true;
      barem = +this.score - 712.5;
      this.value = this.getPercent(barem);
    }
  }

  getPercent(barem) {
    this.widtElement = document.getElementsByClassName('color-4')[0];
    // const result = (barem * this.widtElement.clientWidth) / 137.5;
    console.log(((barem * 100) / 137.5).toFixed(2) + '%');
    return (((barem * 100) / 137.5) - 5).toFixed(2) + '%';
  }
}
